import { DRAFT_STATUS_INFO, CONTENT_STATUS_INFO } from '../../types';
import type { DraftStatus, ContentStatus } from '../../types';

interface DraftStatusBadgeProps {
  status: DraftStatus;
  size?: 'sm' | 'md';
}

export function DraftStatusBadge({ status, size = 'sm' }: DraftStatusBadgeProps) {
  const info = DRAFT_STATUS_INFO[status] || { label: status, color: 'text-gray-700', bgColor: 'bg-gray-100' };
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${info.bgColor} ${info.color} ${sizeClass}`}>
      {info.label}
    </span>
  );
}

interface ContentStatusBadgeProps {
  status: ContentStatus;
  size?: 'sm' | 'md';
}

export function ContentStatusBadge({ status, size = 'sm' }: ContentStatusBadgeProps) {
  const info = CONTENT_STATUS_INFO[status] || { label: status, color: 'text-gray-700', bgColor: 'bg-gray-100' };
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${info.bgColor} ${info.color} ${sizeClass}`}>
      {status === 'processing' && (
        <svg className="mr-1 h-3 w-3 animate-spin" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
      )}
      {info.label}
    </span>
  );
}
